import { NEW_RECORD_PATH } from 'config/consts'

const useAddNewRecord = (props) => {
	const { location: { newRecordAdded, copyId, pathname }, history, section, baseUrl, recordId, replaceOnlyIdOnRoute } = props
	const isNewRecord = recordId === NEW_RECORD_PATH && !newRecordAdded
	const url = `${baseUrl ? baseUrl : ''}/${section}`
	const setNewPath = id => {
		if(!replaceOnlyIdOnRoute) {
			return `${url}/${id}`
		}
		if(!recordId) {
			return `${pathname}/${id}`
		}
		return pathname.replace(recordId, id)
	}

	const startNewRecord = () => {
		history.push({
			pathname: setNewPath(NEW_RECORD_PATH)
		})
	}

	const startCopyRow = id => {
		history.push({
			pathname: setNewPath(NEW_RECORD_PATH),
			copyId: id
		})
	}

	const handleNewRecord = newId => {
		if(newId !== NEW_RECORD_PATH) {
			history.push({
				pathname: setNewPath(newId),
				newRecordAdded: true
			})
		}
	}

	return {
		copyId,
		startNewRecord: startNewRecord,
		startCopyRow: startCopyRow,
		handleNewRecord: handleNewRecord,
		status: newRecordAdded ? 'RECORD_ADDED' : copyId ? 'COPY_RECORD' : isNewRecord ? 'NEW_RECORD' : null
	}
}

export default useAddNewRecord
